export default __webpack_public_path__ + "static/media/chandra.78344f79.jpg";